import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';

const AgreementExpiredSummary = () => (
    <StatusSummaryButton
        href="/start-trygg-betaling"
        statusSummary="Avtaleforslaget har gått ut på tid."
        actionRequiredType="NEGATIVE"
    >
        Send et nytt avtaleforslag
    </StatusSummaryButton>
);

export default AgreementExpiredSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/summaries/agreementExpiredSummary.jsx